export default {
  remove(arr, func) {
    Array.isArray(arr) ? arr.filter(func).reduce((acc, val) => {
      arr.splice(arr.indexOf(val), 1);
      return acc.concat(val);
    }, []) : [];
  },
  getTimeDiff(startTime) {
    let showTime = null;
    if (startTime) {
      let timezone = 9;
      let offset_GMT = new Date().getTimezoneOffset();
      let nowDate = new Date().getTime();
      let time = sd.format(
        new Date(
          nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000
        ),
        "YYYY-MM-DD HH:mm:ss"
      );
      var answerTime = moment(
        new Date(
          startTime.replace(/T/g, " ").replace(/\.[\d]{3}Z/, "")
        )
      ).format("YYYY-MM-DD HH:mm:ss");
      let outTime = "";
      let hours = moment(time).diff(moment(answerTime), "hours");
      if (hours > 0) {
        if (hours < 10) {
          outTime = outTime + "0" + hours + ":";
        } else {
          outTime = outTime + hours + ":";
        }
      } else {
        outTime = outTime + "00:";
      }
      let minutes = moment(time).diff(moment(answerTime), "minutes") % 60;
      if (minutes > 0) {
        if (minutes < 10) {
          outTime = outTime + "0" + minutes + ":";
        } else {
          outTime = outTime + minutes + ":";
        }
      } else {
        outTime = outTime + "00:";
      }
      let seconds =
        (moment(time).diff(moment(answerTime), "seconds") % 60) % 60;
      if (seconds > 0) {
        if (seconds < 10) {
          outTime = outTime + "0" + seconds;
        } else {
          outTime = outTime + seconds;
        }
      } else {
        outTime = outTime + "00";
      }
      showTime = outTime;

    }
    return showTime;
    // }, 1000)
  },
  checkIfInternalLine(line){
    return line && (line.length === 5 || line[0] === '9')
  },
  //remove([1, 2, 3, 4], n => n % 2 == 0) -> [2, 4]

  // 
  splitAllText(allText, tracker='',systemLogoUrl='', userLogoUrl = '') {
    let allTextList =allText.replaceAll("（", "(").replaceAll("）", ")").replaceAll("\r\n", "\n").split("\n--------\n");
    // 会話履歴格式：
    // もっぴー:(2023-05-19 14:35:02) 本日はどのようなご用件でしょうか？お話しいただき、終わりましたら「#」を押してください。
    // --------
    // ゲスト(お問い合わせ者):(2023-05-19 14:35:19)会話内容。
    // マイルの三鷹です。
    // --------
    // ゲスト（お問い合わせ者）:（2023-05-19 14:45:11）会話内容１
    // --------
    // テストop02（オペレーター）:（2023-05-19 14:45:26）会話内容２
    // テストsv01（スーパーバイザー）:（2023-05-19 14:45:26）会話内容3
    let mopyName = "もっぴー:";
    let userName = "(お問い合わせ者):";
    let opName = "(オペレーター):";
    let svName = "(スーパーバイザー):";
    let hisStrList = [];
    allTextList.forEach((hisItem) => {
      // AIの会話のレコードを作成する
      if (hisItem.toString().indexOf(mopyName) != -1 || hisItem.toString().indexOf(opName) != -1 || hisItem.toString().indexOf(svName) != -1) {
        let sysName = (hisItem.toString().indexOf(mopyName) != -1) ? mopyName : ((hisItem.toString().indexOf(opName) != -1) ? opName :svName)
        let time = (hisItem.toString().indexOf(mopyName) == -1 ? hisItem.match(/\((.+?)\)/g)[1] : hisItem.match(/\((.+?)\)/g)[0])
          .replace("\(", "")
          .replace("\)", "");
        let newSysName = sysName.replace(":","")
        let sysNameWithRole = sysName
        if(sysName !== mopyName){
          let systemNameIndex = hisItem.toString().indexOf(sysName)
          newSysName = hisItem.substring(0, systemNameIndex);
          sysNameWithRole = newSysName + sysName;
        }
        let hisItemStr = hisItem
          .replace(sysNameWithRole, "")
          .replace(/\(([^)]*)\)/g, "")
          .replace(/\n/gm, "<br>")
          // .replace("<br><br>", "<br>");
        if (hisItemStr.indexOf("<br>") == 0) {
          hisItemStr = hisItemStr.replace("<br>", "");
        }
        let sysObj = {
          flag: "left",
          text: hisItemStr,
          user: "system",
          username: newSysName,
          messageTime: time,
          logoUrl: systemLogoUrl,
        };
        hisStrList.push(sysObj);
      }
      // ユーザーの会話のレコードを作成する
      if (hisItem.toString().indexOf(userName) != -1) {
        let time = hisItem
          .match(/\((.+?)\)/g)[1]
          .replace("\(", "")
          .replace("\)", "");
        let userNameIndex = hisItem.toString().indexOf(userName);
        let newUserName = hisItem.substring(0, userNameIndex);
        let userNameWithRole = newUserName + userName;
        let hisItemStr = hisItem
          .replace(userNameWithRole, "")
          .replace(/\(([^)]*)\)/g, "")
          .replace(/\n/gm, "<br>");
        let userObj = {
          flag: "right",
          text: hisItemStr,
          user: "user",
          username: newUserName,
          messageTime: time,
          logoUrl:userLogoUrl,
        };
        hisStrList.push(userObj);
      }
    });
    return hisStrList
  },
}
